export enum ANALYTICS_COLUMN_TYPE {
  CLICKS = 'clicks',
  REVENUE = 'revenue',
  QUANTITY_PLACED = 'quantity_placed',
  QUANTITY_ADDED = 'quantity_added',
}
